angular.module('gym.mobile_app').factory('ProximityCheckinLocations', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  var params;
  params = $rootScope.toParams;
  return Restangular.one('gyms', params.gymId).all('mobile_app').all('proximity_checkin_locations');
}]);
